export default __webpack_public_path__ + "static/media/editphoto.349f8b71.svg";